<template>
<ViskaseCard>
    <template v-slot:title> </template>
    <template v-slot:default>
        <div class="row align-items-center">
            <div class="col-12">
                <div class="p-5 text-center">
                    <img class="card-img-left img-responsive p-md-5" style="width: 100%;" src="assets/img/viskase-casing-logo.png" alt="Logo" />
                </div>
            </div>
        </div>
        <div class="row align-items-center p-2">
            <div class="col-xs-2by8 col-sm-1by8" v-for="(language, index) in languages" :key="index">
                <ViskaseTile>
                    <template v-slot:content>
                        <div class="p-1 viskase-language-title" @click="gotoLanguage(language)">
                            <img style="min-width: 50%; min-height:100%;" :src="language.img" :alt="language.name" class="card-img-top card" />
                        </div>
                    </template>
                </ViskaseTile>
            </div>
        </div>
        <div class="row align-items-center ">
            <span class="text-center fw-light text-muted font-size-sm"> ver. 2.0507</span>
        </div>
    </template>
</ViskaseCard>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
import ViskaseTile from "@/components/core/ViskaseTile.vue";
import axios from "axios";
export default {
  name: "Languages",
  components: {
    ViskaseCard,
    ViskaseTile,
  },
  mounted() {
    this.setSelectedSolution({
      title: "",
    });
    this.setSelectedCasing({
      title: "",
    });
    this.setSelectedProduct({
      title: "",
    });
    this.fetchCasingLinks();
    this.fetchCasingFilters();
    this.fetchSolutionCasings();
    this.fetchProductSolutions();
    this.fetchLanguages();
  },
  methods: {
    ...mapActions([
      "fetchLanguages",
      "fetchCasingLinks",
      "fetchSolutionCasings",
      "fetchProductSolutions",
      "fetchCasingFilters",
      "fetchCards",
      "fetchCasingLinks",
      "fetchSolutionCasings",
      "fetchProductSolutions",
      "fetchCasings",
      "fetchSolutions",
      "fetchProducts",
    ]),
    ...mapMutations([
      "setSelectedLanguage",
      "setSelectedSolution",
      "setSelectedCasing",
      "setSelectedProduct",
    ]),
    gotoLanguage(language) {
      this.setSelectedLanguage(language);

      this.fetchCards()
        .then(() => this.fetchProducts())
        .then(() => this.fetchCasings())
        .then(() => this.fetchSolutions())
        .then(() =>
          this.$router.push({
            name: "view",
            params: {
              language: language.name,
            },
          })
        );
    },
  },
  computed: {
    ...mapState(["languages", "cards"]),
  },
};
</script>

<style scoped></style>
